export const shortenName = (name) => {
  if (name && name.length > 60) {
    return name.substr(0, 60) + "...";
  }
  return name;
};
